import { staticImageFile } from '@lib/helpers/publicFiles';

/* eslint-disable no-restricted-properties */
export const bancos: {
  Posicao: number;
  InstituicaoFinanceira: string;
  TaxaJurosAoMes: number;
  TaxaJurosAoAno: number;
  logoPng: string;
  nome: string;
  'tipo de veiculo': string;
  description: string;
  reclameAquiScore: number | string;
  site: string;
}[] = [
  {
    Posicao: 1,
    InstituicaoFinanceira: 'BCO GM S.A.',
    TaxaJurosAoMes: 0.0097,
    TaxaJurosAoAno: 0.12240000000000001,
    logoPng: staticImageFile('logos/chevrolet-financial-services-logo.png'),
    nome: 'Banco General Motors Company',
    'tipo de veiculo': 'Carros',
    description:
      'O Banco GMAC é uma das empresas líderes no mercado de financiamento automotivo no país e faz parte da GM Financial, uma subsidiária da General Motors Company, que por sua vez é uma das maiores produtoras de automóveis do mundo. O banco está em atividade desde 1930 e oferece financiamento, consórcio e seguros para a Rede de Concessionários Chevrolet.',
    reclameAquiScore: 8.8,
    site: 'https://www.gm.com/',
  },
  {
    Posicao: 2,
    InstituicaoFinanceira: 'BANCO CNH INDUSTRIAL CAPITAL S.A',
    TaxaJurosAoMes: 0.011000000000000001,
    TaxaJurosAoAno: 0.1408,
    logoPng: staticImageFile('logos/CNH_Industrial.png'),
    nome: 'Banco CNH Industrial',
    'tipo de veiculo': 'Caminhões Iveco',
    description:
      'Com mais de 40 anos de atuação global, 23 no Brasil e 3 na Argentina e 1 no Chile, o Banco CNH Industrial apresenta soluções financeiras e de seguros para aquisição de máquinas e equipamentos das marcas CNH Industrial e Iveco Group.',
    reclameAquiScore: 'SEM ÍNDICE',
    site: 'https://www.cnhindustrialcapital.com/',
  },
  {
    Posicao: 3,
    InstituicaoFinanceira: 'BCO PACCAR S.A.',
    TaxaJurosAoMes: 0.0118,
    TaxaJurosAoAno: 0.1517,
    logoPng: staticImageFile('logos/paccar.jpeg'),
    nome: 'Paccar Financial',
    'tipo de veiculo': 'Caminhões',
    description:
      'A PACCAR Financial é o braço financeiro da PACCAR, exclusivamente dedicada à indústria de transportes. Oferecemos produtos e serviços financeiros, customizados e sob medida para os nossos clientes, além de um atendimento diferenciado, através de uma equipe exclusiva de Gerentes Regionais de Negócios.',
    reclameAquiScore: 'SEM ÍNDICE',
    site: 'https://www.paccarfinancial.com.br/pt-br',
  },
  {
    Posicao: 4,
    InstituicaoFinanceira: 'BMW FINANCEIRA S.A. - CFI',
    TaxaJurosAoMes: 0.011899999999999999,
    TaxaJurosAoAno: 0.1528,
    logoPng: staticImageFile('logos/bmw.png'),
    nome: 'BMW Serviços Financeiros',
    'tipo de veiculo': 'Carros, motos',
    description:
      'A BMW Financeira S.A. é a instituição financeira ligada à marca BMW, que oferece uma variedade de serviços financeiros relacionados à aquisição e financiamento de veículos da marca BMW e MINI, bem como soluções para clientes corporativos e concessionárias.',
    reclameAquiScore: 8.8,
    site: 'https://www.bmw.com.br/pt/topics/offers-and-services1/financial-services/destaques.html',
  },
  {
    Posicao: 5,
    InstituicaoFinanceira: 'BCO MERCEDES-BENZ S.A.',
    TaxaJurosAoMes: 0.0124,
    TaxaJurosAoAno: 0.1594,
    logoPng: staticImageFile('logos/mercedes.webp'),
    nome: 'Banco Mercedes-Benz',
    'tipo de veiculo': 'Carros, vans, onibus, caminhões',
    description:
      'O Banco Mercedes-Benz atua desde 1996 no Brasil, oferecendo soluções de financiamento e seguros para os veículos da marca Mercedes-Benz (automóveis, caminhões, ônibus e vans). Somos parte da Daimler Truck Financial Services, divisão global de serviços de financiamento e seguros da Daimler Truck AG.',
    reclameAquiScore: 5.8,
    site: 'https://www.bancomercedes-benz.com.br/',
  },
  {
    Posicao: 6,
    InstituicaoFinanceira: 'SCANIA BCO S.A.',
    TaxaJurosAoMes: 0.013000000000000001,
    TaxaJurosAoAno: 0.1671,
    logoPng: staticImageFile('logos/scania.svg'),
    nome: 'Scania Banco',
    'tipo de veiculo': 'Veículo Scania',
    description:
      'O Scania Banco está dedicado em fornecer serviços financeiros flexíveis que proporcionarão maior controle sobre os custos e riscos do seu Scania. Contando com uma equipe composta por profissionais altamente capacitados, do setor financeiro de transporte, oferecemos o pacote completo para soluções em financiamento e seguros.',
    reclameAquiScore: 'SEM ÍNDICE',
    site: 'https://www.scania.com/br/pt/home/services/finance-and-insurance/finance.html',
  },
  {
    Posicao: 7,
    InstituicaoFinanceira: 'BCO VOLVO BRASIL S.A.',
    TaxaJurosAoMes: 0.0132,
    TaxaJurosAoAno: 0.17079999999999998,
    logoPng: staticImageFile('logos/volvo.svg'),
    nome: 'Banco Volvo Brasil',
    'tipo de veiculo': 'carros, carros comerciais, suvs',
    description:
      'o Banco Volvo é a instituição financeira associada à marca de veículos Volvo. O Banco Volvo oferece serviços de financiamento, leasing e soluções financeiras para clientes que desejam adquirir veículos da marca Volvo, incluindo automóveis de passeio, SUVs e veículos comerciais. Eles podem oferecer diversas opções de financiamento para atender às necessidades dos clientes.',
    reclameAquiScore: 'SEM ÍNDICE',
    site: 'https://www.vfsco.com/br/',
  },
  {
    Posicao: 8,
    InstituicaoFinanceira: 'BCO PSA FINANCE BRASIL S.A.',
    TaxaJurosAoMes: 0.013300000000000001,
    TaxaJurosAoAno: 0.17170000000000002,
    logoPng: staticImageFile('logos/stellantis.svg'),
    nome: 'Stellantis Financiamento',
    'tipo de veiculo': 'Carros, camionetes, minivans',
    description:
      'Referência no financiamento de veículos novos e seminovos Citroën, Fiat e Peugeot, a Stellantis Financiamentos oferece soluções financeiras para para que você realize o sonho de ter o automóvel que sempre desejou. E o melhor de tudo isso é que a Stellantis Financiamentos conta com taxas de juros competitivas para financiamento de veículos, além de seguros que acompanham seu momento de vida atual.',
    reclameAquiScore: 7.1,
    site: 'https://stellantisfinanciamentos.com.br/',
  },
  {
    Posicao: 9,
    InstituicaoFinanceira: 'BCO VOLKSWAGEN S.A',
    TaxaJurosAoMes: 0.0137,
    TaxaJurosAoAno: 0.1773,
    nome: 'Banco Volkswagen',
    'tipo de veiculo': 'Carros, onibus, caminhões e motos',
    description:
      'Fundada em 1956, a empresa oferece produtos que facilitam o acesso a automóveis de passeio, veículos comerciais, caminhões e ônibus Volkswagen e MAN Latin America, veículos Audi e motocicletas Ducati. Entre eles estão: Financiamento, Consórcio, Seguro e Leasing Operacional/ Gestão de Frotas.',
    reclameAquiScore: 7,
    site: 'https://www.vwfs.com.br/',
    logoPng: staticImageFile('logos/volks.png'),
  },
  {
    Posicao: 10,
    InstituicaoFinanceira: 'BCO RCI BRASIL S.A.',
    TaxaJurosAoMes: 0.0143,
    TaxaJurosAoAno: 0.1857,
    logoPng: staticImageFile('logos/credinissan.png'),
    nome: 'Credi Nissan',
    'tipo de veiculo': 'Carros Nissan',
    description:
      'O Banco RCI Brasil, instituição financeira integrante do Grupo RCI Banque e do Conglomerado Santander, tem por objeto principal a prática de operações de investimento, arrendamento mercantil e crédito, financiamento e investimento, regulamentado pelo Conselho Monetário Nacional (CMN) e Banco Central do Brasil (Bacen)',
    reclameAquiScore: 7.9,
    site: 'https://portal.bancorenault.com.br/portal/indexRENAULT.html#/',
  },
  // {
  //   Posicao: 11,
  //   InstituicaoFinanceira: 'BANCO MONEO S.A.',
  //   TaxaJurosAoMes: 0.0146,
  //   TaxaJurosAoAno: 0.1902,
  //   logoPng:
  //     'https://www.moneo.com.br/wp-content/uploads/2020/10/logo-moneo.png',
  //   nome: 'Banco Moneo',
  //   'tipo de veiculo': 'Carros, motos, caminhões',
  //   description:
  //     'O Banco Moneo é uma instituição financeira que oferece soluções de crédito para aquisição de veículos novos e usados, com atuação em todo o território nacional. O Banco Moneo é uma instituição financeira que oferece soluções de crédito para aquisição de veículos novos e usados, com atuação em todo o território nacional.',
  //   reclameAquiScore: 7.9,
  //   site: 'https://www.bancomoneo.com.br/financiamento/',
  // },
  {
    Posicao: 12,
    InstituicaoFinanceira: 'BCO RODOBENS S.A.',
    TaxaJurosAoMes: 0.0159,
    TaxaJurosAoAno: 0.209,
    logoPng: staticImageFile('logos/rodobens.svg'),
    nome: 'Rodobens',
    'tipo de veiculo': 'Carros, motos, caminhões',
    description:
      'A Rodobens é uma plataforma de serviços financeiros, alavancada em um ecossistema de varejo automotivo, que distribui seus produtos e serviços em todo o Brasil, combinando canais físicos e digitais, próprios e de parceiros.',
    reclameAquiScore: 8.6,
    site: 'https://rodobens.com.br/',
  },
  {
    Posicao: 13,
    InstituicaoFinanceira: 'BANCO HYUNDAI CAPITAL BRASIL',
    TaxaJurosAoMes: 0.0161,
    TaxaJurosAoAno: 0.21100000000000002,
    logoPng: staticImageFile('logos/hyundai.png'),
    nome: 'Banco Hyundai Capital Brasil',
    'tipo de veiculo':
      'Carros comercializados por meio da rede de Concessionárias Hyundai',
    description:
      'O Banco Hyundai Capital Brasil é uma joint-venture estabelecida entre a Hyundai Capital Services, na Coréia do Sul, e o Banco Santander Brasil. Atuamos sob a marca Hyundai Financiamentos e estamos presentes em toda a rede de concessionárias Hyundai, financiando veículos novos e usados.',
    reclameAquiScore: 6.4,
    site: 'https://bhcb.com.br/',
  },
  {
    Posicao: 14,
    InstituicaoFinanceira: 'BCO BRADESCO S.A.',
    TaxaJurosAoMes: 0.0165,
    TaxaJurosAoAno: 0.2175,
    logoPng: staticImageFile('logos/bradesco-banco.png'),
    nome: 'Banco Bradesco',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'O Bradesco é um dos maiores grupos financeiros do Brasil, com sólida atuação voltada aos interesses de seus clientes desde 1943. Além da excelência em serviços, destaca-se por ser um dos melhores gestores de recursos do mercado, com resultados construídos sobre bases sustentáveis.',
    reclameAquiScore: 6.2,
    site: 'https://banco.bradesco/html/classic/index.shtm',
  },
  {
    Posicao: 15,
    InstituicaoFinanceira: 'FINANC ALFA S.A. CFI',
    TaxaJurosAoMes: 0.0167,
    TaxaJurosAoAno: 0.2193,
    logoPng: staticImageFile('logos/alfa.jpeg'),
    nome: 'Financeira Alfa',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'A história da Financeira Alfa teve início em 1925, quando Aloysio de Andrade Faria fundou o Banco Lavoura de Minas Gerais. Sendo que em 1972 o nome do banco foi alterado para Banco Real. A companhia teve como foco o atendimento a um nicho mais restrito, sem se tornar um banco generalista.',
    reclameAquiScore: 8.1,
    site: 'https://wwws.financeiraalfa.com.br/home',
  },
  {
    Posicao: 16,
    InstituicaoFinanceira: 'BCO DO ESTADO DO RS S.A.',
    TaxaJurosAoMes: 0.0172,
    TaxaJurosAoAno: 0.2274,

    nome: 'Banrisul',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'O Banrisul é um banco múltiplo, controlado pelo Estado do Rio Grande do Sul, com participação de 99,9% do capital social. A instituição financeira foi criada em 1928, com o nome de Banco de Crédito Agrícola e Industrial do Rio Grande do Sul, e tinha como objetivo financiar a produção agrícola e industrial do estado.',
    reclameAquiScore: 6.5,
    site: 'https://www.banrisul.com.br/',
    logoPng: staticImageFile('logos/banrisul.png'),
  },
  {
    Posicao: 17,
    InstituicaoFinanceira: 'BCO TOYOTA DO BRASIL S.A.',
    TaxaJurosAoMes: 0.0174,
    TaxaJurosAoAno: 0.2293,
    logoPng: staticImageFile('logos/toyota.jpeg'),
    nome: 'Banco Toyota',
    'tipo de veiculo': 'Carros',
    description:
      'O Banco Toyota tem condições exclusivas para você que deseja financiar um veículo, seja zero quilômetro ou seminovo. Além disso, conta também com taxas competitivas, flexibilidade para pagar e toda a segurança da marca Toyota. Veja como conquistar o seu veículo de forma simples e rápida.',
    reclameAquiScore: 8.5,
    site: 'https://institucional.bancotoyota.com.br/',
  },
  {
    Posicao: 18,
    InstituicaoFinanceira: 'ITAÚ UNIBANCO HOLDING S.A.',
    TaxaJurosAoMes: 0.018000000000000002,
    TaxaJurosAoAno: 0.23809999999999998,
    logoPng: staticImageFile('logos/itau.png'),
    nome: 'Itaú Unibanco',
    'tipo de veiculo': 'Carro e Caminhão',
    description:
      'O Itau Unibanco Holding S.A. (controlador do Itau Unibanco S.A.) é uma companhia aberta que, em conjunto com empresas coligadas e controladas, atua no Brasil e no exterior na atividade bancária em todas as modalidades.',
    reclameAquiScore: 7.6,
    site: 'https://www.itau.com.br/relacoes-com-investidores/itau-unibanco/governanca-corporativa/estrutura-de-governanca/diretoria-itau-unibanco-holding-s-a/',
  },
  {
    Posicao: 19,
    InstituicaoFinanceira: 'CAIXA ECONOMICA FEDERAL',
    TaxaJurosAoMes: 0.018500000000000003,
    TaxaJurosAoAno: 0.2458,
    nome: 'CAIXA',
    'tipo de veiculo': 'Carro, moto, caminhão, onibus',
    description:
      'A Caixa Econômica Federal (CEF) é uma instituição financeira, sob a forma de empresa pública, com patrimônio próprio e autonomia administrativa com sede em Brasília e com filiais em todo o território nacional, vinculada ao Ministério da Economia.',
    reclameAquiScore: 'NÃO RECOMENDADA',
    site: 'https://www.caixa.gov.br/Paginas/home-caixa.aspx',
    logoPng: staticImageFile('logos/caixa.png'),
  },
  {
    Posicao: 20,
    InstituicaoFinanceira: 'SINOSSERRA S/A - SCFI',
    TaxaJurosAoMes: 0.018500000000000003,
    TaxaJurosAoAno: 0.2464,
    nome: 'Sinossera Financeira',
    'tipo de veiculo': 'Carros',
    description:
      'Com estratégia de crescer em negócios que tenham sinergia com as marcas automotivas representadas pelo Grupo Sinosserra, em 2015 foi constituída a Sinosserra Financeira. Seus produtos são voltados aos clientes, funcionários e fornecedores do Grupo Sinosserra, possibilitando melhores condições de aquisição e pagamento.\nO Grupo Sinosserra é um dos maiores grupos de concessionárias de veículos do Rio Grande do Sul, presente no mercado desde 1947, possuindo também uma longa e sólida tradição no segmento de consórcios, além de atuar nos ramos de Capitalização, Seguros, Financiamentos, Empréstimos e Investimentos.',
    reclameAquiScore: 'SEM ÍNDICE',
    site: 'https://sinosserrafinanceira.com.br/',
    logoPng: staticImageFile('logos/sinoserra.png'),
  },
  {
    Posicao: 21,
    InstituicaoFinanceira: 'SAFRA CFI S.A.',
    TaxaJurosAoMes: 0.018600000000000002,
    TaxaJurosAoAno: 0.247,
    logoPng: staticImageFile('logos/safra.svg'),
    nome: 'Safra Financeira',
    'tipo de veiculo': 'Carro e moto',
    description:
      'A Safra Financeira oferece uma série de produtos com a segurança da marca Safra, como Financiamento de Veículos, Seguro Prestamista, Empréstimo com Garantia do Veículo e Crédito Consignado.',
    reclameAquiScore: 7.6,
    site: 'https://www.safra.com.br/safra-financeira.htm',
  },
  {
    Posicao: 22,
    InstituicaoFinanceira: 'BCO DO BRASIL S.A.',
    TaxaJurosAoMes: 0.0187,
    TaxaJurosAoAno: 0.2488,
    logoPng: staticImageFile('logos/bb.png'),
    nome: 'Banco do Brasil',
    'tipo de veiculo': 'Carro, moto e Caminhão',
    description:
      'O Banco do Brasil (BB) é uma S.A. de capital misto, cujo controle acionário é exercido pela União. É o principal agente financeiro do Governo Federal. Suas três principais funções são: Agente financeiro do Governo Federal: na execução de sua política creditícia e financeira.',
    reclameAquiScore: 7.9,
    site: 'https://www.bb.com.br/site/',
  },
  {
    Posicao: 23,
    InstituicaoFinanceira: 'AYMORÉ CFI S.A.',
    TaxaJurosAoMes: 0.019,
    TaxaJurosAoAno: 0.25329999999999997,
    nome: 'Aymoré Financiamentos',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'A Aymoré Financiamentos é uma empresa do ramo de crédito e financiamento de bens, líder no mercado de Financiamento de Veículos.',
    reclameAquiScore: 'NÃO RECOMENDADA',
    site: 'https://www.santander.com.br/hotsite/santanderfinanciamentos/financiamento-entre-particulares.html?utm_urlsuffix=M11514-24606-83&gclid=CjwKCAjwrranBhAEEiwAzbhNtdZ2ebQdIdgBAwsE7pr_s0v7K9fcBTDvuKhFTtDs5omLnBWHrjpnfhoCyjQQAvD_BwE&gclsrc=aw.ds',
    logoPng: staticImageFile('logos/aymore.svg'),
  },
  {
    Posicao: 24,
    InstituicaoFinanceira: 'BCO C6 S.A.',
    TaxaJurosAoMes: 0.0191,
    TaxaJurosAoAno: 0.25489999999999996,
    logoPng: staticImageFile('logos/c6.png'),
    nome: 'C6 Bank',
    'tipo de veiculo': 'Carro',
    description:
      'O C6 Bank é um banco 100% digital fundado em 2018 por ex-integrantes do banco BTG Pactual. Mas, só em 2019 teve o aval do Banco Central para operar no Brasil.',
    reclameAquiScore: 6.5,
    site: 'https://www.c6bank.com.br/',
  },
  {
    Posicao: 25,
    InstituicaoFinanceira: 'BCO BRADESCO FINANC. S.A.',
    TaxaJurosAoMes: 0.0197,
    TaxaJurosAoAno: 0.2636,
    logoPng: staticImageFile('logos/bradesco-f.png'),
    nome: 'Bradesco',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'O Bradesco é um dos maiores grupos financeiros do Brasil, com sólida atuação voltada aos interesses de seus clientes desde 1943.\nAlém da excelência em serviços, destaca-se por ser um dos melhores gestores de recursos do mercado, com resultados construídos sobre bases sustentáveis.',
    reclameAquiScore: 6.1,
    site: 'https://financiamentos.bradesco/html/home.shtm',
  },
  {
    Posicao: 26,
    InstituicaoFinanceira: 'BCO BANESTES S.A.',
    TaxaJurosAoMes: 0.020499999999999997,
    TaxaJurosAoAno: 0.2763,
    logoPng: staticImageFile('logos/banestes.png'),
    nome: 'Banco do Estado do Espírito Santo',
    'tipo de veiculo': 'Carro, moto',
    description:
      'Banco do Estado do Espírito Santo S.A. é um banco brasileiro, constituído na forma de sociedade de economia mista, com participação do Governo do Estado do Espírito Santo como maior acionista. Foi criado em 1937, é um banco múltiplo controlado pelo estado do Espírito Santo.',
    reclameAquiScore: 6.5,
    site: 'https://www.banestes.com.br/',
  },
  {
    Posicao: 27,
    InstituicaoFinanceira: 'BCO VOTORANTIM S.A.',
    TaxaJurosAoMes: 0.0207,
    TaxaJurosAoAno: 0.2781,
    logoPng: staticImageFile('logos/bv.png'),
    nome: 'Banco BV',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'O Banco Votorantim é atualmente um dos maiores bancos brasileiros em ativos e conta com uma base de acionistas robusta, formada por uma parceria estratégica entre o Banco do Brasil, maior instituição financeira do País, e o Grupo Votorantim – um dos maiores conglomerados privados da América Latina',
    reclameAquiScore: 7.1,
    site: 'https://www.bv.com.br/',
  },
  {
    Posicao: 28,
    InstituicaoFinanceira: 'PORTOSEG S.A. CFI',
    TaxaJurosAoMes: 0.0207,
    TaxaJurosAoAno: 0.2785,
    logoPng: staticImageFile('logos/porto.png'),
    nome: 'Porto Seguro',
    'tipo de veiculo': 'Carro, moto, caminhão, onibus, tratores',
    description:
      'A Portoseg S.A. – Crédito, Financiamento e Investimento (“Portoseg”) é uma\ninstituição financeira privada, constituída em 9 de Novembro de 2001 e autorizada a\nfuncionar pelo Banco Central do Brasil – BACEN em 26 de Dezembro de 2001, com o\nobjetivo de conceder financiamentos para aquisição de bens e serviços e para capital\nde giro, bem como a prática de todas as operações permitidas às instituições\nfinanceiras.',
    reclameAquiScore: 7,
    site: 'https://www.portoseguro.com.br/consulta-de-clientes/portoseg-credito-e-financiamento',
  },
  {
    Posicao: 29,
    InstituicaoFinanceira: 'BCO BRASILEIRO DE CRÉDITO S.A.',
    TaxaJurosAoMes: 0.0212,
    TaxaJurosAoAno: 0.2869,
    nome: 'BANCO BRASILEIRO DE CRÉDITO',
    'tipo de veiculo': 'Carro e Caminhão',
    description:
      'A empresa BANCO BRASILEIRO DE CREDITO S.A, inscrita no CNPJ 01.852.137/0001-37, foi fundada em 03/04/1997 e está com a situação cadastral Ativa na Receita Federal. Este CNPJ é de uma Matriz do tipo Sociedade Anônima Fechada, de porte Demais que está localizada em SAO PAULO - SP.',
    reclameAquiScore: 'SEM ÍNDICE',
    site: 'https://bancobbcdigital.com.br/',
    logoPng: staticImageFile('logos/bbc.svg'),
  },
  {
    Posicao: 30,
    InstituicaoFinanceira: 'BCO SANTANDER (BRASIL) S.A.',
    TaxaJurosAoMes: 0.022099999999999998,
    TaxaJurosAoAno: 0.29969999999999997,
    logoPng: staticImageFile('logos/santander.webp'),
    nome: 'Banco Santander',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'Sediada em São Paulo, a operação brasileira entrou em atividade em 1982 e é parte integrante do Grupo Santander, principal conglomerado financeiro da Zona do Euro. É o terceiro maior banco privado do sistema financeiro do Brasil, com ativos totais de R$ 605,3 bilhões e 31 milhões de clientes no final de 2014.',
    reclameAquiScore: '6,5',
    site: 'https://www.santander.com.br/',
  },
  {
    Posicao: 31,
    InstituicaoFinanceira: 'ITAÚ UNIBANCO S.A.',
    TaxaJurosAoMes: 0.022799999999999997,
    TaxaJurosAoAno: 0.3107,
    logoPng: staticImageFile('logos/itau.png'),
    nome: 'Itaú Unibanco',
    'tipo de veiculo': 'Carro e Caminhão',
    description:
      'Itaú Unibanco, comumente chamado de Itaú, é o maior banco privado do Brasil e maior conglomerado financeiro do hemisfério sul, com sede na cidade de São Paulo, no estado homônimo.',
    reclameAquiScore: 7,
    site: 'https://www.itau.com.br/',
  },
  {
    Posicao: 32,
    InstituicaoFinanceira: 'BCO HONDA S.A.',
    TaxaJurosAoMes: 0.0232,
    TaxaJurosAoAno: 0.31670000000000004,
    logoPng: staticImageFile('logos/honda.png'),
    nome: 'Banco Honda',
    'tipo de veiculo': 'Carro, moto',
    description:
      'O banco da montadora leva no nome a marca Honda, símbolo de confiança, tradição e qualidade. Nosso compromisso é oferecer a você o melhor caminho para conquistar os seus sonhos',
    reclameAquiScore: 8.1,
    site: 'https://www.bancohonda.com.br/',
  },
  {
    Posicao: 33,
    InstituicaoFinanceira: 'BCO YAMAHA MOTOR S.A.',
    TaxaJurosAoMes: 0.0258,
    TaxaJurosAoAno: 0.3568,
    logoPng: staticImageFile('logos/yamaha.png'),
    nome: 'Yamaha Banco',
    'tipo de veiculo': 'moto e produtos náuticos.',
    description:
      'O BANCO YAMAHA foi criado em 2008, com o objetivo de oferecer produtos e serviços para os clientes da Rede de Concessionárias Yamaha. Está ligado diretamente à YAMAHA MOTOR DO BRASIL LTDA, que pertence ao Grupo YAMAHA MOTOR COMPANY. Como um banco ligado a montadora, oferece comodidade e segurança na aquisição de motocicletas e produtos náuticos, com a confiança que a marca Yamaha oferece a você. Na hora de adquirir uma Motocicleta, uma Waverunner ou o seu Motor de Popa, procure uma concessionária e solicite informações sobre os benefícios que os planos do BANCO YAMAHA podem oferecer.',
    reclameAquiScore: 9,
    site: 'https://www.yamaha-motor.com.br/bancoyamaha',
  },
  {
    Posicao: 34,
    InstituicaoFinanceira: 'BCO DIGIMAIS S.A.',
    TaxaJurosAoMes: 0.0273,
    TaxaJurosAoAno: 0.3812,
    logoPng: staticImageFile('logos/digimais.png'),
    nome: 'Banco Digimais',
    'tipo de veiculo': 'Carro',
    description:
      'Banco Digimais, antigo Banco Renner, é um banco brasileiro inaugurado em 1981 pela família Renner, com sede em Porto Alegre. É de propriedade de Edir Macedo e controlado pelo Grupo Record. A instituição financeira é focada em crédito consignado e financiamento de veículos.',
    reclameAquiScore: 6,
    site: 'https://www.bancodigimais.com.br/',
  },
  {
    Posicao: 35,
    InstituicaoFinanceira: 'BRB - CFI S/A',
    TaxaJurosAoMes: 0.0275,
    TaxaJurosAoAno: 0.38549999999999995,
    nome: 'Banco de Brasília S.A',
    'tipo de veiculo': 'Carro, moto',
    description:
      'A Financeira BRB é uma instituição financeira sob a forma de Sociedade Anônima, sendo incorporada ao Conglomerado BRB em 11 de abril de 1986. É controlada majoritariamente pelo BRB – Banco de Brasília S.A., além de ser a única Financeira Pública do Brasil em atividade, atendendo a clientes de várias regiões do País.',
    reclameAquiScore: 5.6,
    site: 'https://novo.brb.com.br/para-voce/emprestimos-e-financiamentos/',
    logoPng: staticImageFile('logos/brb.png'),
  },
  {
    Posicao: 36,
    InstituicaoFinanceira: 'SIMPALA S.A. CFI',
    TaxaJurosAoMes: 0.028999999999999998,
    TaxaJurosAoAno: 0.40990000000000004,

    nome: 'Simpala Financeira',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'Fundada em Porto Alegre, a Simpala Financeira é referência no segmento do mercado financeiro.\n\nNosso objetivo é garantir a perpetuação dos legados e riqueza de nossos clientes através das gerações.\n\nOferecemos serviços de crédito financeiro e excelentes opções de investimento com a transparência, solidez e segurança que você merece. Atuamos com comprometimento e inovação para superar as expectativas de todos que procuram por nossos serviços.\n\nConstruímos e levamos a certeza do melhor negócio para todo o Brasil, com muita transparência e segurança em qualquer serviço.',
    reclameAquiScore: 'SEM ÍNDICE',
    site: 'https://www.simpalafinanceira.com.br/',
    logoPng: staticImageFile('logos/simpala.png'),
  },
  {
    Posicao: 37,
    InstituicaoFinanceira: 'CREDIARE CFI S.A.',
    TaxaJurosAoMes: 0.028999999999999998,
    TaxaJurosAoAno: 0.41,
    logoPng: staticImageFile('logos/crediare.png'),
    nome: 'Crediare',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'A Crediare foi fundada no ano de 2003, subsidiária da Lojas Colombo S.A (rede varejista, que possui mais de 240 filiais, com sede na cidade de Farroupilha - RS, fundada em 1959). Nasceu com o propósito de oferecer aos clientes soluções integradas, de produtos financeiros.',
    reclameAquiScore: 7.7,
    site: 'https://www.crediare.com.br/',
  },
  {
    Posicao: 38,
    InstituicaoFinanceira: 'FINAMAX S.A. CFI',
    TaxaJurosAoMes: 0.0298,
    TaxaJurosAoAno: 0.423,
    logoPng: staticImageFile('logos/finamax.webp'),
    nome: 'Finamax',
    'tipo de veiculo': 'Carro',
    description:
      'A Finamax oferece soluções de crédito, financiamento e investimento a seus clientes. Atua em todo o estado de São Paulo por meio da rede de correspondentes e de plataformas digitais. A financeira é autorizada e regulamentada pelo Banco Central do Brasil.',
    reclameAquiScore: 3.7,
    site: 'https://www.finamax.com.br/',
  },
  {
    Posicao: 39,
    InstituicaoFinanceira: 'BANCO PAN',
    TaxaJurosAoMes: 0.030600000000000002,
    TaxaJurosAoAno: 0.4351,
    logoPng: staticImageFile('logos/pan.svg'),
    nome: 'Banco Pan',
    'tipo de veiculo': 'Carro, moto',
    description:
      'Banco PAN (antigo Banco PanAmericano)[3] é um banco brasileiro, com sede na cidade de São Paulo, no estado homônimo, controlado pelo BTG Pactual.\n\nAtua nas áreas de cartões de crédito, crédito consignado, financiamento de veículos, investimentos de renda fixa e banco digital. Também oferece serviço imobiliário e de adquirência, por meio de aquisições de empresas com a Brazilian Mortgages e Brazilian Securities.',
    reclameAquiScore: 7.4,
    site: 'https://www.bancopan.com.br/',
  },
  {
    Posicao: 40,
    InstituicaoFinanceira: 'BCO DAYCOVAL S.A',
    TaxaJurosAoMes: 0.030899999999999997,
    TaxaJurosAoAno: 0.4415,
    logoPng: staticImageFile('logos/daycoval.png'),
    nome: 'Banco Daycoval',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'O Banco Daycoval é uma instituição financeira de mais de 50 anos no mercado especializada em crédito para empresas, para pessoa física (consignado e financiamento de veículos), produtos de câmbio (comércio exterior e remessa), gestão de recursos e investimentos.',
    reclameAquiScore: 6.2,
    site: 'https://www.daycoval.com.br/',
  },
  {
    Posicao: 41,
    InstituicaoFinanceira: 'OMNI SA CFI',
    TaxaJurosAoMes: 0.0339,
    TaxaJurosAoAno: 0.4927,
    nome: 'Omni Banco & Financeira',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'A Omni foi fundada em 1994, como uma sociedade de crédito, financiamento e investimento, tendo iniciado suas atividades com o financiamento de veículos usados. Hoje, oferece também crédito pessoal, cartão de crédito e financiamento de móveis e utensílios domésticos em lojas e plataformas digitais.',
    reclameAquiScore: 8.2,
    site: 'https://www.omni.com.br/',
    logoPng: staticImageFile('logos/omni.svg'),
  },
  {
    Posicao: 42,
    InstituicaoFinanceira: 'SF3 CFI S.A.',
    TaxaJurosAoMes: 0.0405,
    TaxaJurosAoAno: 0.61,
    logoPng: staticImageFile('logos/sf3.svg'),
    nome: 'SF3',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'Atuamos com financiamento e refinanciamento de veículos, antecipação de recebíveis e capital de giro, microcrédito e investimentos com garantia do FGC. Soluções que atendem empreendedores e seus clientes.',
    reclameAquiScore: 7.6,
    site: 'https://sf3.com.br/',
  },
  {
    Posicao: 43,
    InstituicaoFinanceira: 'BCO RNX S.A.',
    TaxaJurosAoMes: 0.0405,
    TaxaJurosAoAno: 0.6108,
    logoPng: staticImageFile('logos/rnx.png'),
    nome: 'Banco RNX',
    'tipo de veiculo': 'Carro, Moto e Caminhão',
    description:
      'Em setembro de 1987, inicia suas atividades como uma Distribuidora de Títulos e Valores Mobiliários. Com a promulgação da Constituição Federal de 1988, que permitiu a criação de novas instituições financeiras no Brasil, em março de 1989 transforma-se em banco múltiplo com o nome de Banco Maxinvest S/A.\n\nA partir de 1993 o Banco Maxinvest S/A deteve a carteira comercial, propiciando aos clientes da época a movimentação de contas correntes de depósitos à vista. Em 2001, com o advento do Sistema de Pagamentos Brasileiro (SPB), por decisão estratégica, optou por substituir a carteira de banco comercial pela de banco de investimentos.\n\nA partir de então segue a vocação ao crédito, operando nas modalidades de empréstimos, descontos de títulos e financiamentos, para clientes pessoa física e pessoa jurídica.\n\nAgosto de 2019 marcou uma nova fase na vida da instituição, foi aprovado pelo Banco Central do Brasil (BCB) processo de alteração de controle societário.\n\nPensando em proporcionar um melhor atendimento a seus clientes e parceiros, em novembro de 2019 mudou-se para a atual sede, situada na Rua Heitor Stockler de França, 396 - Sala 303 no Ed. Neo Corporate, Centro Cívico.\n\nEm junho de 2020 o BCB homologa a alteração da razão social, quando o Banco Maxinvest S/A passa a ser BANCO RNX S/A.',
    reclameAquiScore: 'SEM ÍNDICE',
    site: 'https://www.bancornx.com.br/',
  },
];

export function vehiclModelYear(year: number) {
  if (year === 32000) return '0km';
  return year;
}

export const medianTaxaJurosAoMes =
  bancos.reduce((acc, banco) => acc + banco.TaxaJurosAoMes, 0) / bancos.length;

export const medianTaxaJurosAoAno =
  bancos.reduce((acc, banco) => acc + banco.TaxaJurosAoAno, 0) / bancos.length;

// create a function to calculate a vehicle loan
export const calculateVehicleLoanMensalidade = (
  vehicleValue: number,
  months: number,
  interestRate: number,
) => {
  // calculate the monthly payment
  const monthlyPayment =
    (vehicleValue * interestRate) / (1 - Math.pow(1 + interestRate, -months));

  // return the monthly payment
  return monthlyPayment;
};

// create a function to calculate a vehicle loan total
export const calculateVehicleLoanTotal = (
  vehicleValue: number,
  months: number,
  interestRate: number,
) => {
  // calculate the monthly payment
  const monthlyPayment =
    (vehicleValue * interestRate) / (1 - Math.pow(1 + interestRate, -months));

  // return the monthly payment
  return monthlyPayment * months;
};
